var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AsyncIterator = require('asynciterator'); // https://en.wikipedia.org/wiki/Symmetric_Hash_Join


var SymmetricHashJoin =
/*#__PURE__*/
function (_AsyncIterator) {
  "use strict";

  _inherits(SymmetricHashJoin, _AsyncIterator);

  function SymmetricHashJoin(left, right, funHash, funJoin) {
    var _this;

    _classCallCheck(this, SymmetricHashJoin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SymmetricHashJoin).call(this));
    _this.left = left;
    _this.right = right;
    _this.funHash = funHash;
    _this.funJoin = funJoin;
    _this.usedLeft = false;
    _this.leftMap = new Map();
    _this.rightMap = new Map();

    _this.on('end', function () {
      return _this._cleanup();
    });

    _this.match = null;
    _this.matches = [];
    _this.matchIdx = 0;

    _this.left.on('readable', function () {
      return _this.readable = true;
    });

    _this.right.on('readable', function () {
      return _this.readable = true;
    }); // this needs to be here since it's possible the left/right streams only get ended after there are no more results left


    _this.left.on('end', function () {
      if (!_this.hasResults()) _this._end();
    });

    _this.right.on('end', function () {
      if (!_this.hasResults()) _this._end();
    });

    return _this;
  }

  _createClass(SymmetricHashJoin, [{
    key: "hasResults",
    value: function hasResults() {
      return !this.left.ended || !this.right.ended || this.matchIdx < this.matches.length;
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      // motivate garbage collector to remove these
      this.leftMap = null;
      this.rightMap = null;
      this.matches = null;
    }
  }, {
    key: "close",
    value: function close() {
      _get(_getPrototypeOf(SymmetricHashJoin.prototype), "close", this).call(this);

      this.left.close();
      this.right.close();
    }
  }, {
    key: "read",
    value: function read() {
      if (this.ended) return null;

      while (this.matchIdx < this.matches.length) {
        var _item = this.matches[this.matchIdx++];
        var result = this.usedLeft ? this.funJoin(this.match, _item) : this.funJoin(_item, this.match);
        if (result !== null) return result;
      }

      if (!this.hasResults()) this._end();
      var item = null; // try both streams if the first one has no value

      for (var i = 0; i < 2; ++i) {
        item = this.usedLeft ? this.right.read() : this.left.read();
        this.usedLeft = !this.usedLeft; // try other stream next time
        // found a result, no need to check the other stream this run

        if (item !== null) break;
      }

      if (item === null) {
        this.readable = false;
        return null;
      }

      var hash = this.funHash(item);
      var map = this.usedLeft ? this.leftMap : this.rightMap;
      if (!map.has(hash)) map.set(hash, []);
      var arr = map.get(hash);
      arr.push(item);
      this.match = item;
      this.matches = (this.usedLeft ? this.rightMap : this.leftMap).get(hash) || [];
      this.matchIdx = 0; // array is filled again so recursive call can have results

      return this.read();
    }
  }]);

  return SymmetricHashJoin;
}(AsyncIterator);

module.exports = SymmetricHashJoin;